import { render, staticRenderFns } from "./modalApproveDocuments.vue?vue&type=template&id=29c9a749&scoped=true&"
import script from "./modalApproveDocuments.vue?vue&type=script&lang=js&"
export * from "./modalApproveDocuments.vue?vue&type=script&lang=js&"
import style0 from "./modalApproveDocuments.vue?vue&type=style&index=0&id=29c9a749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c9a749",
  null
  
)

export default component.exports